import React, { createContext, useContext } from 'react'

import { customStore } from './custom-store'
import { progressStore } from './progress-store'

const global = {
  customStore,
  progressStore,
}

export const globalContext = createContext(global)

export const GlobalContext: React.FC<{ children?: React.ReactNode }> = ({ children }) => {
  return <globalContext.Provider value={global}> {children} </globalContext.Provider>
}

export const useGlobalContext = () => useContext(globalContext)
